import { SearchApiClient, type Context } from '@bc/discovery/domain/catalog';
import { http } from '@monolith/legacy/services/api/http';

export const getSearchClient = (context?: Context) => new SearchApiClient(http(), window.location.host, context);
